import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"
import cookies from "@/utils/cookie"

// 新服推荐换一批
interface GetRandomOpenListData {
    token: string,
}
export const getRandomOpenList = (json: GetRandomOpenListData): any => http.httpPost({
    url: httpApi.home.get_random_open_list,
    json,
})

// 推荐页
interface HomeindexData {
    token: string,
}
export const homeindex = (json: HomeindexData): any => http.httpPost({
    url: httpApi.home.homeindex,
    json,
})

// 推荐页-开服列表筛选
interface GetIndexOpenListJson {
    token: string,
    versionid: string,
    tag: string,
    stime: string,
    etime: string
}
export const getIndexOpenList = (json: GetIndexOpenListJson): any => http.httpPost({
    url: httpApi.home.get_index_open_list,
    json
})

interface GetNewsListData {
    token: string,
    size: string,
    page: string,
    is_seo: number
}
// 新闻列表
export const getNewsList = (json: GetNewsListData): any => http.httpPost({
    url: httpApi.home.getNewsList,
    json
})


interface GetNewsInfoData {
    token: string,
    id: string,
}
// 获取新闻详情
export const getNewsInfo = (json: GetNewsInfoData): any => http.httpPost({
    url: httpApi.home.getNewsInfo,
    json
})

interface ByRandData {
    token: string
}
// 发现页信息
export const byRand = (json: ByRandData): any => http.httpPost({
    url: httpApi.home.byRand,
    json
})

interface WithRankData {
    token: string,
    versionid: string,
    tag: string,
    type: string,
    page: string,
    size: number
}
// 排行页信息
export const withRank = (json: WithRankData): any => http.httpPost({
    url: httpApi.home.withRank,
    json
})

// 版本与标签接口
export const tagList = (json: ByRandData): any => http.httpPost({
    url: httpApi.home.tagList,
    json
})

interface HotSearchJson {
    token: string
}
// 游戏热搜数据
export const hotSearch = (json: HotSearchJson): any => http.httpGet({
    url: httpApi.home.hot_search,
    json
})

interface QueryPrefixJson {
    cueword: string
}
// 搜索框提示词
export const queryPrefix = (json: QueryPrefixJson): any => http.httpGet({
    url: httpApi.home.query_prefix,
    json
})

// 搜索框随机提示词
export const getCueWord = (json: HotSearchJson) => http.httpGet({
    url: httpApi.home.getCueWord,
    json
})

interface EsSearchJson {
    search_info: string
}
// 游戏搜索页
export const esSearch = (json: EsSearchJson): any => http.httpPost({
    url: httpApi.home.es_search,
    json
})

// 清空历史记录
interface DelHistoryJson {
    id: object,
    uid: string
}
export const delHistory = (json: DelHistoryJson): any => http.httpPost({
    url: httpApi.home.del_history,
    json
})

// 删除单条历史记录
interface DelSingleHistoryJson {
    token: string,
    id: object
}
export const delSingleHistory = (json: DelSingleHistoryJson): any => http.httpPost({
    url: httpApi.home.del_single_history,
    json
})

interface GetTodayNewServerListJson {
    token: string,
    section_id: string,
    size: number,
    page: number,
    versionid: string,
    tag: string
}
// 新服页-今日开服
export const getTodayNewServerList = (json: GetTodayNewServerListJson): any => http.httpPost({
    url: httpApi.home.getTodayNewServerList,
    json
})

interface GetFutureNewServerListJson {
    token: string,
    section_id: string,
    size: number,
    page: number,
    versionid: string,
    tag: string
}
// 新服页-即将开服
export const getFutureNewServerList = (json: GetFutureNewServerListJson): any => http.httpPost({
    url: httpApi.home.getFutureNewServerList,
    json
})

interface GetTimeSectionJson {
    token: string,
}
// 时间段配置获取
export const getTimeSection = (json: GetTimeSectionJson): any => http.httpPost({
    url: httpApi.home.getTimeSection,
    json
})

interface CommentListJson {
    token: string,
    box_game_id: string,
}
// 获取评论
export const commentList = (json: CommentListJson): any => http.httpPost({
    url: httpApi.home.commentList,
    json
})

interface MyCommentJson {
    token: string,
    box_game_id: string,
}
// 我的评论
export const myComment = (json: MyCommentJson): any => http.httpPost({
    url: httpApi.home.myComment,
    json
})

interface AddCommentJson {
    token: string,
    box_game_id: string,
    stars_score: string,
    user_name: string,
    head_portrait: string,
    content: string,
    play_game_time: string
}
// 添加评论
export const addComment = (json: AddCommentJson): any => http.httpPost({
    url: `${httpApi.home.addComment}`,
    json
})

interface UserCommentListJson {
    token: string,
    comment_id: string,
    box_game_id: string,
}
// 评论回复列表
export const userCommentList = (json: UserCommentListJson): any => http.httpPost({
    url: `${httpApi.home.userCommentList}`,
    json
})

interface AddUserCommentJson {
    token: string,
    comment_id: string,
    box_game_id: string,
    user_name: string,
    to_uid: string,
    to_user_name: string,
    head_portrait: string,
    content: string,
    comment_content: string,
    reply_id: string
}
// 回复评论
export const addUserComment = (json: AddUserCommentJson): any => http.httpPost({
    url: httpApi.home.addUserComment,
    json
})

interface DelUserCommentJson {
    token: string,
    id: string,
    box_game_id: string,
    comment_id: string
}
// 删除回复
export const delUserComment = (json: DelUserCommentJson): any => http.httpPost({
    url: httpApi.home.delUserComment,
    json
})

interface DelCommentJson {
    token: string,
    id: string,
    box_game_id: string,
}
// 删除评论
export const delComment = (json: DelCommentJson): any => http.httpPost({
    url: httpApi.home.delComment,
    json
})

interface CommentPraiseJson {
    token: string,
    type: string,
    box_game_id: string,
    comment_id: string
}
// 评论页点赞
export const commentPraise = (json: CommentPraiseJson): any => http.httpPost({
    url: httpApi.home.commentPraise,
    json
})

interface ReplyPraiseJson {
    token: string,
    type: string,
    box_game_id: string,
    comment_id: string,
    reply_id: string
}
// 回复页点赞
export const replyPraise = (json: ReplyPraiseJson): any => http.httpPost({
    url: httpApi.home.replyPraise,
    json
})

// 黑词库屏蔽
export const getBlackWords = () => http.httpGet({
    url: httpApi.home.getBlackWords
})

// 获取QQ一键加群KEY
export const getQQKey = () => http.httpGet({
    url: httpApi.home.getQQKey
})
